module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAANtJREFUKBVjNDEx8WRgYJj1//9/GSBNFGBkZHwCVJjGAiRmAXH62bNntxGlE6jI2NjYG2jALBDjP7GakNWB9DEhC5DKBjkbA5iampYAw0CalZW16vjx498xFEAFsNoM1CgJxAW/fv26CHSeDUmakRSrAtkHgTHSb2lpyYkkDmZitRlNERPMFegGEKMZZNYHYNS0oPufGM1bODg4tM+cObMIzUUMWEMbqghkWz42TTBDsNrMzMw8F6hAC59GkAFYbT558uQ1mOn4aCZQIgelVXyK0OVA6kH6GCnJVQCPzUo/s6v+XQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notPlay.png
// module id = 2Hks
// module chunks = 1